import React, { useMemo } from 'react';
import { useUser } from 'hooks';
import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import { projectStateType, userType } from 'types';
import { Hollow, hollowColorType } from 'components/Buttons';
import useUserFunctions from 'hooks/user/useUserFunctions';
import { projectsNotShowSimulator } from 'types/idProject';

const getVariantProps = (variant) => {
  let investColorType = hollowColorType.primary;
  let simulateColorType = hollowColorType.YELLOW;
  switch (variant) {
    case 'primary': {
      investColorType = hollowColorType.primary;
      simulateColorType = hollowColorType.WhiteBorder;
      break;
    }
    default: {
      break;
    }
  }
  return { investColorType, simulateColorType };
};

export default function ProjectInvertButtons({
  isDesktop, status, onInvertClick, variant, minWidth,
  maxWidth, padding, fontSize, mb, justify, projectId, onSimulateClick,
}) {
  const { isLogin, type } = useUser();
  const { isVIP } = useUserFunctions();
  const variantProps = useMemo(() => getVariantProps(variant), [variant]);
  return (
    <Grid
      container
      style={{ rowGap: '10px' }}
      justify={justify || 'center'}
    >
      {status === projectStateType.OPEN && (!isLogin || type === userType.USER) && !isVIP && (
        <StyledHollow
          isSubmit
          size={fontSize}
          padding={padding}
          minWidth={minWidth}
          maxWidth={maxWidth}
          mr={isDesktop && 60}
          onClick={onInvertClick}
          width={isDesktop ? 26 : 100}
          onColorType={variantProps.investColorType}
          disabled={status !== projectStateType.OPEN}
          mb={mb === undefined ? (!isDesktop && 16) : mb}
        >
          Invertir
        </StyledHollow>
      )}

      {!projectsNotShowSimulator?.includes(projectId) && (

      <StyledHollow
        isSubmit
        size={fontSize}
        padding={padding}
        maxWidth={maxWidth}
        minWidth={minWidth}
        onClick={onSimulateClick}
        width={isDesktop ? 26 : 100}
        onColorType={variantProps.simulateColorType}
      >
        Simular inversión
      </StyledHollow>
      )}

    </Grid>
  );
}

const StyledHollow = styled(Hollow)((props) => ({
  minWidth: props.minWidth,
  maxWidth: props.maxWidth,
}));
